// ─────────────────────────────────────────────────────────────────────────────
// Splash screen (logo NoleggioinCloud)
//
// L'elemento #nic-splash vive in public/index.html, quindi compare al primo
// paint, PRIMA che il JavaScript venga scaricato. Qui decidiamo solo quando
// nasconderlo: resta visibile finché almeno un <LoadingScreen /> è montato
// (auth/dati in caricamento, chunk lazy) e sparisce con un fade quando l'app
// è pronta. Compare SOLO al caricamento/refresh della pagina: dopo il primo
// nascondimento non ricompare più durante la navigazione nel sito.
// ─────────────────────────────────────────────────────────────────────────────

// Tempo minimo (ms dall'apertura della pagina) prima del primo nascondimento:
// evita che su connessioni veloci il logo "lampeggi" per un istante.
// Metti 0 per rimuovere il tempo minimo.
const MIN_FIRST_VISIBLE_MS = 700;

// Piccola attesa prima di nascondere: se un altro LoadingScreen si monta subito
// dopo (es. da "auth in caricamento" a "chunk lazy"), lo splash non sfarfalla.
const HIDE_DELAY_MS = 120;

let holders = 0;
let timer = null;
let firstHideDone = false;

function setVisible(visible) {
  const el = document.getElementById('nic-splash');
  if (!el) return;
  const progress = window.__nicSplashProgress;
  if (progress) (visible ? progress.start : progress.finish)();
  el.classList.toggle('is-hidden', !visible);
  el.setAttribute('aria-hidden', visible ? 'false' : 'true');
}

function scheduleHide() {
  clearTimeout(timer);
  let delay = HIDE_DELAY_MS;
  if (!firstHideDone && typeof performance !== 'undefined') {
    // performance.now() parte dall'inizio della navigazione: il tempo di
    // caricamento della pagina conta già come tempo di visibilità.
    delay = Math.max(delay, MIN_FIRST_VISIBLE_MS - performance.now());
  }
  timer = setTimeout(() => {
    if (holders === 0) {
      firstHideDone = true;
      setVisible(false);
    }
  }, delay);
}

/** true dopo che lo splash iniziale è stato nascosto (o sta per esserlo). */
export function isSplashDone() {
  return firstHideDone;
}

/** Tiene lo splash visibile (solo finché non è stato nascosto la prima volta). */
export function holdSplash() {
  holders += 1;
  clearTimeout(timer);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders = Math.max(0, holders - 1);
    if (holders === 0) scheduleHide();
  };
}

/** Rete di sicurezza: se l'app non monta nessun LoadingScreen, nasconde comunque lo splash. */
export function hideSplashWhenIdle() {
  if (holders === 0) scheduleHide();
}
